var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui basic fluid center aligned segment"},[_c('h1',{staticClass:"ui header"},[_vm._v("Uh-Oh! "),_c('div',{staticClass:"sub header"},[_vm._v(_vm._s(_vm.error))])])])}
var staticRenderFns = []

export { render, staticRenderFns }